export const readIdFromReferredData = (referredData: any) => {
  if (referredData === null || !referredData) return;
  const id = referredData._delegate._key.path.segments;
  console.log('id:', id);
  if(id[6] === undefined) return id[1];
  else return id[6];
}
